import { useTranslation } from 'react-i18next';
import AdminCommentIcon from 'components/atoms/icons/adminCommentIcon';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { FC } from 'react';

interface TriggerProps {
  setExpanded: (value: boolean) => void;
  isStandalone?: boolean;
  onOpen: () => void;
  opened: boolean;
  hasAssignToolNearby?: boolean;
}

const Trigger: FC<TriggerProps> = ({
  setExpanded,
  isStandalone = false,
  onOpen,
  opened,
  hasAssignToolNearby,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(s['key-note-trigger'], {
        [s.standalone]: isStandalone,
      })}
      data-cy="keyNote-side-button"
      data-move-down={hasAssignToolNearby}
      id="key-note-trigger"
    >
      <div
        className={s['trigger-content']}
        onClick={() => {
          if (opened) {
            setExpanded(false);
          }
          onOpen();
        }}
      >
        <span className={s['comment-icon']}>
          <AdminCommentIcon />
        </span>
        <span className={s['minified-hidden']}>{t('labels.keyNote')}</span>
      </div>
    </div>
  );
};
export default Trigger;
